import React from 'react'
import { Outlet, useMatches } from 'react-router-dom'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Link from '~/client/components/Link'

export default function TabsLayout({ tabs, context, ...props }) {
  const matches = useMatches()
  const { pathname } = matches[matches.length - 1]
  const tab = [...tabs].reverse().find(tab => pathname.startsWith(tab.path) )?.path
  return <Container {...props}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', my: 2 }}>
      <Tabs value={tab}>
        {tabs.map(tab =>
          <Tab {...{
            key: tab.label,
            component: Link,
            to: tab.path,
            value: tab.path,
            label: tab.label,
          }}/>
        )}
      </Tabs>
    </Box>
    <Outlet context={context}/>
  </Container>
}
